export { logJSON } from './log/log';
export { API_URL, FULL_API_URL, WS_API_URL } from './apiUrl/apiUrl';
export { serviceUrlPrefix } from './serviceUrlPrefix/serviceUrlPrefix';
export { generateCSV } from './files/csv';

export const getScopeOneUrl = (path) => `https://staging.dev.scope-one.com/ca/${path}`;

/*
  An ISIN is a 12-character code that identifies a financial security.

  An ISIN consists of three parts:
  • A two-letter country code
  • A nine-character alphanumeric national security identifier
  • A single check digit.

  For example: US9311421039 (Walmart)

  Financial and referential instruments issued in the European Union but not relating to a specific EU country jurisdiction would be allocated an ISIN with an EU-prefix.
*/
export const isIsin = (value) => /^[A-Z]{2}[0-9A-Z]{9}[0-9]{1}$/i.test(value);

export const equals = (target, match, caseSensitive = false) =>
  caseSensitive ? target === match : target?.toLowerCase() === match?.toLowerCase();
